import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {AbstractControl} from '@angular/forms';

enum colorPickerSegmentEnum {
  COLOR = 'COLOR',
  BACKGROUND = 'BACKGROUND'
}

@Component({
  selector: 'app-color-picker-modal',
  templateUrl: './color-picker-modal.component.html',
  styleUrls: ['./color-picker-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ColorPickerModalComponent implements OnInit {
  @Input() presetColors : string [] = [];
  @Input() sliceControl: AbstractControl = {} as AbstractControl;
  ionSegmentCurrentValue = colorPickerSegmentEnum.COLOR;
  get colorPickerSegment() {
    return colorPickerSegmentEnum;
  }
  constructor(
    private modalCtrl: ModalController
  ) { }

  ngOnInit() {}

  onColorPickerChange(color: string) {
    this.sliceControl.patchValue({color})
  }

  onBackgroundPickerChange(background: string) {
    this.sliceControl.patchValue({background});
  }

  async selectColor() {
     await this.modalCtrl.dismiss();
  }

  switchSegment($event: any) {
    setTimeout( () => {
      this.ionSegmentCurrentValue = $event.detail.value;
    }, 200);
  }
}
